// ============================================================
// FILE: src/components/ProjectCard.jsx
// ============================================================
import React from 'react';
import { motion } from 'framer-motion';
// import { ExternalLink } from 'lucide-react';

const ProjectCard = ({ title, category, image, delay = 0 }) => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay }}
            whileHover={{ y: -6, scale: 1.01 }}
            whileTap={{ scale: 0.98 }}
            className="group relative overflow-hidden rounded-[28px] border border-[var(--color-border)]/70 bg-white/90 shadow-[0_16px_50px_rgba(20,39,70,0.08)]"
        >
            <div className="aspect-video overflow-hidden">
                <img
                    src={image}
                    alt={title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
            </div>

        </motion.div>
    );
};

export default ProjectCard;